var render = function () {
  var _vm$data, _vm$data2;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bonus-card",
    class: [{
      'bonus-card_hover': _vm.isShareButtonHover
    }],
    style: {
      height: _vm.height
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "bonus-card__balance"
  }, [_vm.props.userAuth ? _c('div', {
    staticClass: "bonus-card__balance-label"
  }, [_vm._v("\n      Баланс карты:\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bonus-card__balance-value"
  }, [_vm._v("\n      " + _vm._s(_vm.props.userAuth ? Math.trunc(_vm.balance) : '000') + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "bonus-card__footer"
  }, [_c('div', {
    staticClass: "bonus-card__row"
  }, [_c('div', {
    staticClass: "bonus-card__item"
  }, [_c('span', {
    staticClass: "bonus-card__item-label"
  }, [_vm._v("Номер карты")]), _vm._v(" "), _c('span', {
    staticClass: "bonus-card__item-value"
  }, [_vm._v(_vm._s(((_vm$data = _vm.data) === null || _vm$data === void 0 ? void 0 : _vm$data.number) || '№########'))])]), _vm._v(" "), _c('div', {
    staticClass: "bonus-card__item bonus-card__item_right"
  }, [_c('span', {
    staticClass: "bonus-card__item-label"
  }, [_vm._v("дата регистрации")]), _vm._v(" "), _c('span', {
    staticClass: "bonus-card__item-value"
  }, [_vm._v(_vm._s((_vm$data2 = _vm.data) === null || _vm$data2 === void 0 ? void 0 : _vm$data2.dateRegister))])])]), _vm._v(" "), _vm.showCode ? _c('div', {
    staticClass: "bonus-card__code"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/svg/profile/bar-code.svg")
    }
  })]) : _vm._e()])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bonus-card__row"
  }, [_c('img', {
    staticClass: "bonus-card__logo",
    attrs: {
      "src": require("@/assets/images/svg/05-logo.svg"),
      "alt": "05.ru"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bonus-card__item bonus-card__item_right"
  }, [_c('span', {
    staticClass: "bonus-card__name"
  }, [_vm._v("bonus card")])])]);
}]

export { render, staticRenderFns }